import React from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'redux-zero/react';
import { CardInfo, PageHeader, PageTitle, PageSubTitle } from '@tokenyico/tokeny-ui';
import { DsExplorerLink, DsLogo } from '@tokenyico/design-system/dist/reactJS';

const ProfileOnchainidView = ({ investor, selectedToken }) => {
  const { t } = useTranslation();

  const walletStatus = investor.walletsAndStatus.find(
    (w) => w.identityRegistryStorage === selectedToken.identityRegistryStorage,
  );

  const wallet = walletStatus ? (
    <DsExplorerLink address={walletStatus.wallet} network={selectedToken.blockchainNetwork} />
  ) : (
    '-'
  );
  const identityAddress = investor.identityAddress ? (
    <DsExplorerLink
      address={investor.identityAddress}
      network={selectedToken.blockchainNetwork}
      type="onchainid"
    />
  ) : (
    '-'
  );

  const walletItems = [
    {
      label: t('shared.wallet'),
      value: wallet,
    },
  ];
  const infoItems = [
    {
      label: t('shared.address'),
      value: identityAddress,
    },
  ];
  return (
    <div className="mh3">
      <PageHeader>
        <PageTitle>
          <DsLogo name="onchainid" style={{ width: '6rem', height: '2rem' }} />
        </PageTitle>
        <PageSubTitle>{t('shared.onchainidDescription')}</PageSubTitle>
      </PageHeader>
      <CardInfo title={t('shared.identity')} infoItems={infoItems} />
      <CardInfo title={t('shared.connectedWallet')} infoItems={walletItems} />
    </div>
  );
};

const mapToProps = ({ holder: { user, selectedToken } }) => ({ investor: user, selectedToken });

export default connect(mapToProps)(ProfileOnchainidView);
